import qs from "qs";
import { useLocation } from "react-router-dom";

/**
 * Given a query param key, return the value. If no value, return undefined or pass in a defaultValue to return.
 *
 */
export function useQueryParam(key: string): string | undefined;

export function useQueryParam(key: string, defaultValue: string): string;

export function useQueryParam(
  key: string,
  defaultValue?: string
): string | undefined {
  const { search } = useLocation();

  const params = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  const value = params[key];
  return typeof value === "string" ? encodeURIComponent(value) : defaultValue;
}
